import { render, staticRenderFns } from "./parametrosForm.vue?vue&type=template&id=b4b91f9c&"
import script from "./parametrosForm.vue?vue&type=script&lang=js&"
export * from "./parametrosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports